"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDyingStyles = void 0;
const react_jss_1 = require("react-jss");
exports.useDyingStyles = (0, react_jss_1.createUseStyles)({
    "@keyframes piece-dying-anim": {
        "100%": {
            transform: "scale(0)",
        },
    },
    "dying": {
        animationName: "$piece-dying-anim",
        animationDuration: "1000ms",
        animationFillMode: "forwards",
        animationIterationCount: "1",
    },
});
